import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customEmailValidator(): ValidatorFn {
  // Regular expression for a valid email pattern
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null; // don't validate if the field is empty
    
    const email = control.value;
    
    // Ensure total email length does not exceed 320 characters
    if (email.length > 320) {
      return { email: true };
    }
    
    // Ensure username (before @) is between 1 and 64 characters
    const [username, domain] = email.split('@');
    if (!username || username.length > 64 || username.length < 1) {
      return { email: true };
    }
    
    // Ensure domain + mail server (after @) is between 1 and 255 characters
    if (!domain || domain.length > 255 || domain.length < 1) {
      return { email: true };
    }

    // Check for incorrect domains
    const domainRegex = /@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!domainRegex.test(email)) {
      return { email: true };
    }

    // Additional checks for incomplete addresses
    if (email.endsWith('.') || email.endsWith('@') || /\.[a-zA-Z]{1}$/.test(email) || email.includes('@.') || email.includes('..')) {
      return { email: true };
    }
    
    // Validate username rules
    if (/^[-.]|[-.]$|\.\./.test(username)) {
      return { email: true }; // Cannot start or end with dot/hyphen, no consecutive dots
    }
    
    // Validate domain rules    
    if (!domain.includes('.')) {
      return { email: true };
    }

    // Split domain into labels and validate each
    const domainLabels = domain.split('.');
    for (const label of domainLabels) {
      if (
        !label ||
        label.length > 63 ||
        /^-/.test(label) ||
        /-$/.test(label) ||
        /[^a-zA-Z0-9-]/.test(label)
      ) {
        return { email: true };
      }
    }
    
    // Ensure email follows correct format
    if (!emailRegex.test(email)) {
      return { email: true };
    }
    
    return null;
  };
}